import { roundRect } from '../renderers';
import { lineFont } from '../state/font';
import { BasicObject } from '../uiObjects/basicObject';

import {
  LABEL_FONT_SIZE,
  LABEL_RECT_RADIUS,
  LABEL_HEIGHT,
  MARGIN,
} from './SectionedHelpConstants';

export class SectionLabel extends BasicObject {
  label: string;

  constructor(label: string, width: number, y = 0) {
    super();
    this.label = label;
    this.viewportX = 0;
    this.viewportY = y;
    this.viewportW = width;
    this.viewportH = LABEL_HEIGHT;
    this.gmmName = 'sectionLabel';
    this.paintMe = this.paintLabel.bind(this);
  }

  private paintLabel(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    ctx.font = `${LABEL_FONT_SIZE}px ${lineFont}`;
    const textWidth = ctx.measureText(this.label).width;

    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = '#404040';
    ctx.beginPath();
    roundRect(
      ctx,
      0,
      0,
      textWidth + 2 * MARGIN,
      this.viewportH,
      LABEL_RECT_RADIUS
    );
    ctx.fill();
    ctx.fillStyle = 'white';
    ctx.fillText(this.label, MARGIN, MARGIN / 2 + 1);
    ctx.restore();
  }
}
